export const transferFieldData = (props) => {
  const { setFormSubmissionPayload, dataObject, operation } = props;
  const {
    changePageValues,
    setChangePageValues,
    curPageValues,
    setCurPageValues,
    selectedVal,
  } = dataObject;
  const {
    dataTransferMapping,
    compareToValue,
    persistToFormSubmissionPayload,
  } = operation;
  if (dataTransferMapping && dataTransferMapping.mapping) {
    const payloadUpdate = {};
    dataTransferMapping.mapping.forEach((mapping) => {
      const fromFieldIds = Array.isArray(mapping.fromFieldId)
        ? mapping.fromFieldId : [mapping.fromFieldId];
      fromFieldIds.forEach((fromFieldId) => {
        if (selectedVal === compareToValue) {
          if (persistToFormSubmissionPayload) {
            payloadUpdate[mapping.toFieldId] = curPageValues[fromFieldId] || '';
          } else {
            changePageValues[mapping.toFieldId] = changePageValues[fromFieldId] || '';
            curPageValues[mapping.toFieldId] = changePageValues[fromFieldId] || '';
          }
        } else if (persistToFormSubmissionPayload) {
          payloadUpdate[mapping.toFieldId] = '';
        } else {
          changePageValues[mapping.toFieldId] = '';
          curPageValues[mapping.toFieldId] = '';
        }
      });
    });
    // Persist to formSubmissionPayload if flag is set
    if (persistToFormSubmissionPayload && setFormSubmissionPayload) {
      setFormSubmissionPayload((prev) => ({
        ...prev,
        ...payloadUpdate,
      }));
    }
    setChangePageValues({ ...changePageValues });
    setCurPageValues({ ...curPageValues });
  }
};
